import i18n from 'i18next';
import LngDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { LocaleTag } from './i18nTypes';

import nl from './locales/nl.json';
import en from './locales/en.json';
import fr from './locales/fr.json';

export const lngDetector = new LngDetector();

const resources: {
  [L in LocaleTag]: { translation: Record<string, unknown> };
} = {
  [LocaleTag.NL]: {
    translation: nl,
  },
  [LocaleTag.FR]: {
    translation: fr,
  },
  [LocaleTag.EN]: {
    translation: en,
  },
};

export const initialize = () =>
  i18n
    .use(lngDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      debug: false,
      interpolation: {
        escapeValue: false,
      },
      resources,
      fallbackLng: LocaleTag.NL,
      react: {
        nsMode: 'fallback',
      },
      detection: {
        // order and from where user language should be detected
        order: ['querystring', 'localStorage'],

        // keys or params to lookup language from
        lookupQuerystring: 'locale',

        // cache user language on
        caches: ['localStorage'],
      },
    });
